import React from 'react';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { Box } from '@mui/material';
import PrivateRoutes from '../../core/routes/PrivateRoutes';
import { Layout } from '../../core/components/Layout';
import { PainelEstacao } from '../pages/PainelEstacao';
import { PainelExpedicao } from '../pages/PainelExpedicao';
import { ConfiguracaoCozinha } from '../pages/ConfiguracaoCozinha';
import { ConfiguracoesCardapioProvider } from '../../produtos/contexts/ConfiguracoesCardapioContext';
import { ConfiguracaoFluxoOperacao } from '../../configuracoes/pages/ConfiguracaoFluxoOperacao';

/**
 * Layout sem header global — usado pelos painéis full-screen de cozinha.
 * Ocupa 100vw × 100vh sem nenhum padding extra do layout principal.
 */
const LayoutSemHeader: React.FC = () => (
    <Box sx={{ width: '100vw', height: '100vh', overflow: 'hidden', position: 'fixed', top: 0, left: 0 }}>
        <Outlet />
    </Box>
);

interface CozinhaRoutesProps {
    autenticado: boolean;
}

export const CozinhaRoutes = ({ autenticado }: CozinhaRoutesProps) => {
    return (
        <Routes>
            {/* Rotas com layout normal (header + menu lateral) */}
            <Route
                element={
                    <Layout titulo="Cozinha">
                        <PrivateRoutes autenticado={autenticado} />
                    </Layout>
                }
            >
                <Route path="/configuracao" element={<ConfiguracaoCozinha />} />
                <Route
                    path="/fluxo/operacao"
                    element={
                        <ConfiguracoesCardapioProvider>
                            <ConfiguracaoFluxoOperacao />
                        </ConfiguracoesCardapioProvider>
                    }
                />
                <Route path="/" element={<Navigate to="/cozinha/configuracao" replace />} />
            </Route>

            {/* Rotas full-screen — sem header global */}
            <Route element={<PrivateRoutes autenticado={autenticado} />}>
                <Route element={<LayoutSemHeader />}>
                    <Route path="/painel/:estacaoUuid" element={<PainelEstacao />} />
                    <Route path="/expedicao" element={<PainelExpedicao />} />
                </Route>
            </Route>

            <Route path="*" element={<Navigate to="/pagina-nao-encontrada" />} />
        </Routes>
    );
};
